import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { StatusMenu } from "@common/models/status-menu";
import { environment } from "environments/environment";

@Injectable({ providedIn: 'root'})
export class StatusMenuService{
    constructor(private _http: HttpClient){}

    /**
     * Funcion que devuelve listado de estados segun el Menu ID
     * @param id Entero que identifica al menu
     * @returns devuelve listado de estados segun ID de parametro
     */
    getByMenuId(id: number){
        return this._http.get<StatusMenu[]>(`${environment.commonApiUrl}/api/status/${id}`);
    }
}
